export default __webpack_public_path__ + "static/media/sticker-t.b6b72387.png";